import { parseTipoCertificado } from 'components/UsuarioGeneral/Solicitud Certificados/Solicitud_Certificados';
import React, { createRef, useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
//Componentes
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, FormGroup, Label, Container, Input } from "reactstrap";
import { DatosVistaPrevia, PersonalFirmaCertificado } from './AnalistaAdministraSolicitudesCertificados';
import SelectItem from "components/Varios/select";
import { alertService } from 'components/Varios/alert_service';
import axios, { AxiosRequestConfig } from 'axios';
//url
import configData from "../../../config.json";
import { authenticationService } from 'services/authentication.service';
import { UserData } from 'components/Sidebar/Sidebar_Principal';
import InputFileUpload from '../Vacaciones/InputFileUploadComponent';
import { FileInfo, FileInfoUrl } from '../Vacaciones/ModalFirmarReporteAnual';
import { handle_error } from 'components/DirectivoUnidad/Vacaciones/helper_function';
import { DatosModalFirmarCertificado } from './FirmarCertificados';
import Cargando from 'components/Varios/Cargando';


type ModalFirmarCertificadoProps = {
    show: boolean,
    toogle: () => void,
    onClose: () => void,
    datosparaFirmar: DatosModalFirmarCertificado,
    handleCertificadoFirmado: () => void,
}



export default function ModalFirmarCertificado(props: ModalFirmarCertificadoProps) {

    const [loadingFirma, setloadingFirma] = useState<boolean>(false)
    const [fileEnviar, setfileEnviar] = useState<FileInfoUrl>()
    const [contrasenia, setcontrasenia] = useState<string>()
    const [mostrarConfirmacionFirma, setmostrarConfirmacionFirma] = useState<boolean>(false);

    const ButtonAcept: React.RefObject<HTMLButtonElement> = createRef();

    function handleFileUploadChange(archivo: FileInfo) {
        var uploadFile = new File([archivo.file], archivo.id + ".pdf");

        const src = window.URL.createObjectURL(uploadFile);

        const firmaArchivoInfo: FileInfoUrl = {
            nombreFile: archivo.nombreFile,
            file: uploadFile,
            id: archivo.id,
            url: src
        };

        setfileEnviar(firmaArchivoInfo)
    }

    function handleChangeContra(e: string) {
        var _contrasenia_ = new TextEncoder().encode(e).toString();

        setcontrasenia(_contrasenia_)
    }

    async function FirmarDocumento(idCertificado:number) {
        var botonAceptar = document.getElementById("botonAceptar");
        var botonCancelar = document.getElementById("botonCancelar");
        var contenedor_errores = document.getElementById("contenedor_errores");

        if (fileEnviar) {
            if (contrasenia === "" || contrasenia === undefined || contrasenia === null) {
                const small_texto = document.createElement("small");
                small_texto.innerText = "Debe ingresar su contraseña\n";
                if (contenedor_errores) {
                    while (contenedor_errores.firstChild) {
                        if (contenedor_errores.lastChild != null) {
                            contenedor_errores.removeChild(contenedor_errores.lastChild);

                        }
                    }
                    contenedor_errores.append(small_texto);
                }

                return false
            }

            const i = document.createElement("i");
            i.setAttribute("id", "loadingEnviar")
            i.setAttribute("class", "fa fa-spin fa-spinner")
            if (botonAceptar && botonCancelar) {
                botonAceptar.textContent = "Enviando... "
                botonAceptar.insertBefore(i, null)
                botonAceptar.setAttribute("disabled", "true")
                botonCancelar.setAttribute("disabled", "true")
            }

            var currentUser = authenticationService.currentUserValue;



            const formData = new FormData();

            formData.append("files", fileEnviar.file, fileEnviar.file.name);
            formData.append("contrasenia", contrasenia)
            let instance = axios.create({ baseURL: configData.SERVER_URL });
            let options: AxiosRequestConfig = {
                url: `GenerarCertificados/Director/FirmarCertificado/${idCertificado}`,
                data: formData,
                method: "POST",
                responseType: "blob",
                headers: {
                    Authorization: `KEYESPOL ${currentUser?.token}`
                }
                // don't forget this
            };
            try {
                await instance.request<any>(options).then((response) => {

                    //let url = window.URL.createObjectURL(new Blob([response.data]));
                    //let a = document.createElement('a');
                    //a.href = url;
                    //a.download = "certificado_firmado.pdf"  //nombrearchivo
                    //a.click()
                });
                if (botonAceptar && botonCancelar) {
                    botonAceptar.textContent = "Enviado"
                    botonAceptar.setAttribute("disabled", "true")
                    botonCancelar.setAttribute("disabled", "false")
                }
                setmostrarConfirmacionFirma(true);
                props.handleCertificadoFirmado()

            } catch (error) {
                var error_any: any = error;
                var status_number = handle_error(error_any);
                var mensaje_error: string = "Error desconocido. Intente más tarde";
                switch (status_number) {
                    case 500:
                        mensaje_error = "Error inesperado. Intente más tarde"
                        break;
                    case 0:
                        mensaje_error = "No ha sido posible conectarse con el servidor. Intente más tarde"
                        break;

                    case 401:
                        mensaje_error = "No está autorizado a realizar esta acción";
                        break;

                    case 409:
                        mensaje_error = await new Blob([error_any.response.data], { type: 'application/octet-text/plain; charset=utf-8' }).text();
                        break;

                    default:
                        mensaje_error = "Ha ocurrido un error inesperado";
                        break;
                }

                contenedor_errores = document.getElementById("contenedor_errores");
                if (contenedor_errores) {
                    var error_small_element = document.createElement("small");                                        
                    error_small_element.innerText = mensaje_error + "\n";
                    if (contenedor_errores) {
                        while (contenedor_errores.firstChild) {
                            if (contenedor_errores.lastChild != null) {
                                contenedor_errores.removeChild(contenedor_errores.lastChild);
    
                            }
                        }
                        contenedor_errores.append(error_small_element);
                    }                   
                }
                if (botonAceptar && botonCancelar) {
                    botonCancelar.removeAttribute("disabled")
                    botonAceptar.removeAttribute("disabled")
                    i.remove();
                    botonAceptar.textContent = "Guardar"
                }

            }

        }
        else {
            if (botonAceptar && botonCancelar && contenedor_errores) {
                var small_texto_certificado_vacio = document.createElement("small");
                small_texto_certificado_vacio.id = "error_certificado"
                small_texto_certificado_vacio.innerText = "Debe adjuntar su firma/certificado electrónica\n";
                if (contenedor_errores) {
                    while (contenedor_errores.firstChild) {
                        if (contenedor_errores.lastChild != null) {
                            contenedor_errores.removeChild(contenedor_errores.lastChild);

                        }
                    }
                    contenedor_errores.append(small_texto_certificado_vacio);
                }



            }


        }

    }

    if(loadingFirma){
        return (            
            <Modal
                isOpen={true}
                scrollable={true}
                fullscreen={"xl"}
                centered={true}
                onClosed={() => false}
            >
                <ModalBody>
                    <div>
                        <Cargando mensaje='Firmando Certificado' />
                    </div>
                </ModalBody>
            </Modal>            
        )
    }

    function CloseModal(){
        setloadingFirma(false);
        setfileEnviar(undefined)
        setcontrasenia("")
        setmostrarConfirmacionFirma(false)
        
        props.onClose();
        document.body.classList.remove('modal-open')
    }


    return (
        <Modal
            isOpen={props.show}
            scrollable={true}
            size={"xl "}
            fullscreen={"xl"}
            centered={true}
            onClosed={()=> CloseModal()}
            contentClassName="custom-modal-style"

        >
            <ModalHeader
                close={<i onClick={() => props.toogle()} className="fa-solid fa-xmark" />}

            >
                Firmar Certificado
            </ModalHeader>
            <ModalBody className="" >
                {

// <div className="containerPdfCertificadoVP" >
// <object data={props.datos.url + "#zoom=80"}
//     type="application/pdf"
//     className= { (encabezadoDirigido || props.datos.ids.tieneDirigido) ?'container-pdf-dirigido':'container-pdf'}

// >

// </object>
// </div>
                    props.datosparaFirmar.url !== "" &&
                    <div className="containerPdfCertificadoFirma mb-3">
                        <object data={props.datosparaFirmar.url + "#zoom=80"}
                            type="application/pdf"
                            className='container-pdf-firma '
                        >

                        </object>
                    </div>
                }
                <Container>
                    <Row form className="mt-3">
                        <Col md={6}>
                            <FormGroup>
                                <Label for="nombremencion">Certificado*</Label>
                                <InputFileUpload
                                    icon="upload"
                                    onChange={(archivo: FileInfo) => handleFileUploadChange(archivo)}
                                    name="DOC"
                                    id="CERT"
                                    placeholder="Subir firma electrónica"
                                />
                            </FormGroup>
                        </Col>
                        <Col md={6}>
                            <FormGroup>
                                <Label for="nombremencion">Contraseña*</Label>
                                <Input
                                    type="password"
                                    name="contrasenia"
                                    id="contrasenia"
                                    placeholder=""
                                    onChange={(e) => handleChangeContra(e.target.value)}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <div id="contenedor_errores" className="errores_firmar">

                    </div>
                </Container>
                {
                    mostrarConfirmacionFirma &&
                    <React.Fragment>
                        <Row className="justify-content-center">
                            <Col sm={12} md={12} xl={10} className="text-center">
                                El documento se ha firmado correctamente. Espere un momento por favor.
                            </Col>

                        </Row>


                    </React.Fragment>
                }
           

                    <button   id="botonCancelar" className="btn btn-secondary" onClick={() => CloseModal()}>
                        Cancelar
                    </button>
                    <Button 
                        color="primary" 
                        id="botonAceptar" 
                            onClick={() => FirmarDocumento(props.datosparaFirmar.idCertificado)} 
                            ref={ButtonAcept} >Firmar Certificado</Button>


                

            </ModalBody>
            {/* <ModalFooter>


              
            </ModalFooter> */}
        </Modal>
    )
}
